import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Add.svg?component
var Add_exports = /* @__PURE__ */ __exportAll({
	default: () => Add_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M5 11.988h14M12.006 5v14"
	}, null, -1)])]);
}
var Add_default = { render: render$1 };
//#endregion
export { Add_exports, Add_default as default, render$1 as render };

//# sourceMappingURL=Add.svg_component.js.map